import { render, staticRenderFns } from "./MaterialProperty.vue?vue&type=template&id=5554487a"
import script from "./MaterialProperty.vue?vue&type=script&lang=js"
export * from "./MaterialProperty.vue?vue&type=script&lang=js"
import style0 from "./MaterialProperty.vue?vue&type=style&index=0&id=5554487a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports